import React, { useCallback } from 'react';

import { CurrencyInput } from 'ui-components/components/currency-input';

import { INSURANCE_VALUE_CHANGED_CSW } from '../../constants/analytics-events';
import { useEnableInsurancePromoExperiment } from '../../feature-flags/hooks/use-enable-insurance-promo-experiment';
import { useInsurancePreference } from '../../hooks/use-insurance-preference';
import { Segment } from '../../services/analytics-services/segment';

/**
 * @param {object} props
 * @param {Currency} props.insuredAmount
 * @param {(value: number, code: string) => void} props.onChange
 * @param {string} [props.className]
 * @param {boolean} [props.disabled]
 * @param {string} [props.currencySymbolClassName]
 * @param {string} [props.labelId]
 * @param {string} [props.rowClassName]
 * @returns {JSX.Element}
 */
const InsuredAmountInput = ({ insuredAmount, onChange, className, disabled = false, currencySymbolClassName, labelId, rowClassName }) => {
  const isInsurancePromoExperimentEnabled = useEnableInsurancePromoExperiment();
  const { insurancePreferenceForAnalytics } = useInsurancePreference();

  const onChangeCb = useCallback(
    (value) => {
      onChange(value, insuredAmount.code);
    },
    [insuredAmount.code, onChange],
  );

  const onBlurCb = useCallback(
    (value) => {
      onChange(value, insuredAmount.code);
      Segment.trackEvent(INSURANCE_VALUE_CHANGED_CSW, {
        version: isInsurancePromoExperimentEnabled ? 'v1' : 'v0',
        insurancePreference: insurancePreferenceForAnalytics,
      });
    },
    [insuredAmount.code, onChange, isInsurancePromoExperimentEnabled, insurancePreferenceForAnalytics],
  );

  return (
    <div className={rowClassName}>
      <CurrencyInput
        className={className}
        currencyCode={insuredAmount.code}
        currencySymbolClassName={currencySymbolClassName}
        data-testid='insured-amount'
        disabled={disabled}
        labelId={insuredAmount.code}
        onBlur={onBlurCb}
        onChange={onChangeCb}
        onFocus={onChangeCb}
        parentLabelId={labelId}
        value={insuredAmount.value}
      />
    </div>
  );
};

export default InsuredAmountInput;
